export default __webpack_public_path__ + "static/ceinture.mobile.inspirations-7f6fe64e11300d80349200d77a37fd59.jpg";